import axios from "./axios";

export const createUser = async (data) => {
  return await axios.post("/user", data);
};

export const deleteUser = async (id) => {
  return await axios.delete(`/user/${id}`);
};
